import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import '../styles/layout.css';

const Header = ({ title = 'Dashboard', onMenuToggle }) => {
  const { user } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    if (onMenuToggle) {
      onMenuToggle(!mobileMenuOpen);
    }
  };

  // Generate user initials from first and last name
  const getInitials = () => {
    if (!user) return 'U';
    const firstName = user.firstName || 'User';
    const lastName = user.lastName || '';
    return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
  };

  const getUserName = () => {
    if (!user) return 'User';
    return `${user.firstName || ''} ${user.lastName || ''}`.trim();
  };

  return (
    <header className="header">
      <div className="header-left">
        <button
          className="btn-menu-toggle"
          onClick={handleMenuToggle}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
        <h2 className="page-title">{title}</h2>
      </div>

      <div className="header-right">
        <div className="user-badge">
          <div className="avatar">
            <span>{getInitials()}</span>
          </div>
          <div className="user-info">
            <span className="user-name">{getUserName()}</span>
            {user && user.role && (
              <span className="user-role">{user.role}</span>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
